// 본래 common-util 라이브러리로 난독화 해야 하는데, yarn start만 되고 yarn build 하면 node_modules에서 오류가 발생하여 어쩔 수 없이 포탈에서 가져옴
// http://wiki.duzon.com:8080/pages/viewpage.action?pageId=201426445
// http://wiki.duzon.com:8080/pages/viewpage.action?pageId=196027786
// http://git.duzon.com/ui/wehago-ui/blob/servicedev/src/app/utils/k.js
// http://git.duzon.com/ui/wehago-ui/blob/servicedev/src/app/utils/ajax.js
// 기준: "common-util": "git+http://ui-common-module:abN-uXv2ivQ6yzVzPHVU@git.duzon.com/ui/common.git#1.0.20"
let n = Symbol('n');
let a = Symbol('a');
let g = Symbol('g');
let o = Symbol('o');
let s = Symbol('s');
let w = Symbol('w');
let e = Symbol('e');
let h = Symbol('h');
let i = Symbol('i');

const ws1 = [
    w.description
    ,e.description
    ,h.description
    ,a.description
    ,g.description
    ,o.description
]
 
const ws2 = [
    s.description
    ,i.description
    ,g.description
    ,n.description
]

export const ws3 = [ws1.join(''), ws2.join('')].join('-')
export const ws4 = [ws1.join(''),s.description].join('_')

const getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }

    return "";
}

// [주의] 설치형 프로그램에서는 쿠키를 못 가져오므로 로직 추가함
const getStorageKeyData = (key) => {
    if (getCookie(key)) {
        return getCookie(key);
    }

    if (localStorage.getItem(key)) {
        return localStorage.getItem(key);
    }

    if (sessionStorage.getItem(key)) {
        return sessionStorage.getItem(key);
    }

    return null;
};
 
const getTransactionId = () => {
    const uuidV1 = require('uuid/v1');
    const randomstring = uuidV1().replace(/-/g, "");
    return randomstring;
}
 
const getWS = (url, transactionId, ts = Math.floor(Date.now() / 1000), hashKey) => {
    const CryptoJS = require('crypto-js');
    hashKey = hashKey ? CryptoJS.SHA256((hashKey + ts).toString(CryptoJS.enc.Utf8), hashKey).toString(CryptoJS.enc.Base64) : "";  // hashKey가 null일 때 + 연산을 하면 RangeError: toString() radix argument must be between 2 and 36 오류가 콘솔로그를 도배해서 예외처리 추가
    let ws = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(url.pathname + url.search + ts + transactionId, hashKey));
 
    return {
        key: ws3,
        value: ws
    }
};
 
const getLocation = (url) => {
    // eslint-disable-next-line
    const match = url.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7],
    }
}
 
const getReqHeaderInfo = (url, hashKey=getStorageKeyData(ws4)) => {
    const transactionId = getTransactionId();
    const ts = Math.floor(Date.now() / 1000);
    const ws = getWS(url, transactionId, ts, hashKey);
    return {
        transactionId: { key: "transaction-id", value: transactionId },
        ts: { key: "timestamp", value: ts },
        ws,
    }
}

/**
 * 인증정보 가져오기 새 버전
 */
const getAuthInfo = (url) => {
    const targetUrl = getLocation(url);
    const info = getReqHeaderInfo(targetUrl);

    // 난독화
    const obfuscateValue1 = info.transactionId.value;
    const obfuscateValue2 = info.ws.value;
    const obfuscateValue3 = info.ts.value;

    // 나머지는 그대로 냅둠
    const service = "";
    const clientId = "communication";
    const _token = getCookie("AUTH_A_TOKEN");
    const token = _token ? `Bearer ${_token}` : false;

    return {
        obfuscateValue1,
        obfuscateValue2,
        obfuscateValue3,
        service,
        clientId,
        token,
        info,
    };
};

// 최종 결과물 (헤더 주입할 때 사용)
export const getRequestHeaders = (url) => {
    try {
        const authInfo = getAuthInfo(url);  // 인증정보 가져오기 새 버전
        const {
            obfuscateValue1,
            obfuscateValue2,
            obfuscateValue3,
            service,
            clientId,
            token,
            info,
        } = authInfo;
    
        if(!token) {
            return {}
        }

        // 난독화 추가 (http://wiki.duzon.com:8080/pages/viewpage.action?pageId=196027786)
        const obfuscateKey1 = info.transactionId.key;
        const obfuscateKey2 = info.ws.key;
        const obfuscateKey3 = info.ts.key;
    
        const secretObj = {}
        secretObj[obfuscateKey1] = obfuscateValue1;
        secretObj[obfuscateKey2] = obfuscateValue2;
        secretObj[obfuscateKey3] = obfuscateValue3;
        secretObj["client-id"] = clientId;
        secretObj["authorization"] = token;
        secretObj["service"] = service;

        return secretObj;
    } catch (error) {
        console.log(error);
        return {}
    }
};